'use client'

import { useEffect } from 'react'

export default function Karte() {
  useEffect(() => {
    // staging と production 環境のみ実行
    if (
      process.env.NEXT_PUBLIC_ENVIRONMENT !== 'staging' &&
      process.env.NEXT_PUBLIC_ENVIRONMENT !== 'production'
    ) {
      return
    }

    // KARTEスクリプトの読み込み待機
    function waitForKarte(loopLimit: number, i: number): void {
      if (i <= loopLimit) {
        setTimeout(() => {
          if (!window.krt || typeof window.krt !== 'function') {
            waitForKarte(loopLimit, ++i)
          }
        }, 300)
      }
    }

    if (!window.krt || typeof window.krt !== 'function') {
      waitForKarte(3, 0)
    }
  }, [])

  return null
}
